/**
 * Copyright © 2025-2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { FC, ReactNode } from "react";
import { useSelector } from "react-redux";
import { RouteObject } from "react-router-dom";

import { Gate, SelectorGate } from "../../components/AppRouter/route-gates";
import { usePermission } from "../../hooks/usePermission";
import { selectShouldShowActivities } from "../../services/firebase/remote-config/remoteConfig.slice";
import { HOME_ROUTE } from "../../util/routing";
import { selectIsThisTfo } from "../azure-b2c/storage";

import Activities from "./pages/Activities";
import ActivityDetails from "./pages/ActivityDetails";
import { ACTIVITIES_ROUTES, ACTIVITY_DETAIL_ROUTE } from "./constants";

type ActivitiesPermissionGateProps = {
  redirectTo: string;
  children?: ReactNode;
};

const ActivitiesPermissionGate: FC<ActivitiesPermissionGateProps> = ({ redirectTo, children }) => {
  const isTfo = useSelector(selectIsThisTfo) ?? false;
  const permission = usePermission("StaffSpecific_Activities_ActivitiesView");
  const canView = isTfo && (permission.allowed || permission.isLoading);

  return (
    <Gate enabled={canView} redirectTo={redirectTo}>
      {children}
    </Gate>
  );
};

export const activitiesRoutes: RouteObject[] = [
  {
    element: <SelectorGate selector={selectShouldShowActivities} redirectTo={HOME_ROUTE} />,
    children: [
      {
        element: <ActivitiesPermissionGate redirectTo={HOME_ROUTE} />,
        children: [
          { path: ACTIVITIES_ROUTES.BASE, element: <Activities /> },
          { path: ACTIVITY_DETAIL_ROUTE, element: <ActivityDetails /> },
        ],
      },
    ],
  },
];
